import ModelUtil from '@leverege/model-util';
import { DEFAULT_RANGES } from "../Constants.js";
const TYPE = 'graph.PieChart';
const DEFAULT_MARGIN = {
  top: 10,
  right: 0,
  bottom: 10,
  left: 0
};
function create(extend) {
  return {
    type: TYPE,
    margin: DEFAULT_MARGIN,
    size: 115,
    innerRadius: null,
    cornerRadius: null,
    padAngle: null,
    attribute: null,
    limit: 10,
    includeNull: false,
    valueRanges: DEFAULT_RANGES,
    strokeColor: null,
    strokeWidth: 1,
    label: {
      align: true,
      visible: false,
      color: 'white',
      fontFamily: 'Inter',
      fontSize: 16,
      xOffset: null,
      yOffset: null,
      angle: null,
      threshold: 0.1
    },
    rollover: {
      visible: true,
      paneVariant: 'detailContent',
      labelFlexVariant: null,
      labelTextVariant: 'detailTitle',
      countFlexVariant: null,
      countTextVariant: 'detailLabel',
      countValueVariant: 'detailValue',
      percentFlexVariant: null,
      percentTextVariant: 'detailLabel',
      percentValueVariant: 'detailValue',
      labelVisible: true,
      countVisible: true,
      percentVisible: true
    },
    innerCount: {
      visible: true,
      color: 'var(--color-base700)',
      fontFamily: 'Inter',
      fontSize: 48,
      yOffset: 0,
      total: true
    },
    innerTitle: {
      visible: true,
      color: 'var(--color-base700)',
      fontFamily: 'Inter',
      fontSize: 26,
      yOffset: 40,
      text: null
    },
    key: {
      visible: true,
      titleVariant: 'detailTitle',
      labelVariant: 'detailValue',
      countVariant: 'detailLabel',
      animate: true,
      title: null
    },
    backgroundColor: '#FFFFFF',
    ...extend
  };
}
function indexOfValueRange(model, item) {
  return model.valueRanges == null ? -1 : model.valueRanges.findIndex(range => range?.name === item?.name);
}
export default {
  create,
  TYPE,
  getMargin: ModelUtil.createGetValue('margin'),
  getLabel: ModelUtil.createGetValue('label'),
  getRollover: ModelUtil.createGetValue('rollover'),
  getKey: ModelUtil.createGetValue('key'),
  getInnerCount: ModelUtil.createGetValue('innerCount'),
  getInnerTitle: ModelUtil.createGetValue('innerTitle'),
  ...ModelUtil.createAllValue('attribute'),
  ...ModelUtil.createAllValue('limit'),
  ...ModelUtil.createAllValue('includeNull'),
  ...ModelUtil.createAllArray('valueRanges'),
  indexOfValueRange,
  ...ModelUtil.createAllValue('margin/top', 'topMargin'),
  ...ModelUtil.createAllValue('margin/right', 'rightMargin'),
  ...ModelUtil.createAllValue('margin/bottom', 'bottomMargin'),
  ...ModelUtil.createAllValue('margin/left', 'leftMargin'),
  ...ModelUtil.createAllValue('size'),
  ...ModelUtil.createAllValue('donutSize'),
  ...ModelUtil.createAllValue('cornerRadius'),
  ...ModelUtil.createAllValue('padAngle'),
  ...ModelUtil.createAllValue('strokeColor'),
  ...ModelUtil.createAllValue('strokeWidth'),
  ...ModelUtil.createAllValue('labelColor'),
  ...ModelUtil.createAllValue('fontFamily'),
  ...ModelUtil.createAllValue('backgroundColor'),
  ...ModelUtil.createAllValue('label/color', 'labelColor'),
  ...ModelUtil.createAllValue('label/visible', 'labelVisible'),
  ...ModelUtil.createAllValue('label/xOffset', 'labelXOffset'),
  ...ModelUtil.createAllValue('label/yOffset', 'labelYOffset'),
  ...ModelUtil.createAllValue('label/angle', 'labelAngle'),
  ...ModelUtil.createAllValue('label/align', 'labelAlign'),
  ...ModelUtil.createAllValue('label/threshold', 'labelThreshold'),
  ...ModelUtil.createAllValue('label/fontFamily', 'labelFontFamily'),
  ...ModelUtil.createAllValue('label/fontSize', 'labelFontSize'),
  ...ModelUtil.createAllValue('rollover/visible', 'rolloverVisible'),
  ...ModelUtil.createAllValue('rollover/paneVariant', 'rolloverPaneVariant'),
  ...ModelUtil.createAllValue('rollover/labelFlexVariant', 'rolloverLabelFlexVariant'),
  ...ModelUtil.createAllValue('rollover/countFlexVariant', 'rolloverCountFlexVariant'),
  ...ModelUtil.createAllValue('rollover/percentFlexVariant', 'rolloverPercentFlexVariant'),
  ...ModelUtil.createAllValue('rollover/labelTextVariant', 'rolloverLabelTextVariant'),
  ...ModelUtil.createAllValue('rollover/countTextVariant', 'rolloverCountTextVariant'),
  ...ModelUtil.createAllValue('rollover/countValueVariant', 'rolloverCountValueVariant'),
  ...ModelUtil.createAllValue('rollover/percentTextVariant', 'rolloverPercentTextVariant'),
  ...ModelUtil.createAllValue('rollover/percentValueVariant', 'rolloverPercentValueVariant'),
  ...ModelUtil.createAllValue('rollover/labelVisible', 'rolloverLabelVisible', null, {
    defaultValue: true
  }),
  ...ModelUtil.createAllValue('rollover/countVisible', 'rolloverCountVisible', null, {
    defaultValue: true
  }),
  ...ModelUtil.createAllValue('rollover/percentVisible', 'rolloverPercentVisible', null, {
    defaultValue: true
  }),
  ...ModelUtil.createAllValue('key/visible', 'keyVisible'),
  ...ModelUtil.createAllValue('key/animate', 'keyAnimate'),
  ...ModelUtil.createAllValue('key/title', 'keyTitle'),
  ...ModelUtil.createAllValue('key/titleVariant', 'keyTitleVariant'),
  ...ModelUtil.createAllValue('key/labelVariant', 'keyLabelVariant'),
  ...ModelUtil.createAllValue('key/countVariant', 'keyCountVariant'),
  ...ModelUtil.createAllValue('innerCount/visible', 'innerCountVisible'),
  ...ModelUtil.createAllValue('innerCount/color', 'innerCountColor'),
  ...ModelUtil.createAllValue('innerCount/yOffset', 'innerCountYOffset'),
  ...ModelUtil.createAllValue('innerCount/fontFamily', 'innerCountFontFamily'),
  ...ModelUtil.createAllValue('innerCount/fontSize', 'innerCountFontSize'),
  ...ModelUtil.createAllValue('innerCount/total', 'innerCountTotal'),
  ...ModelUtil.createAllValue('innerTitle/visible', 'innerTitleVisible'),
  ...ModelUtil.createAllValue('innerTitle/text', 'innerTitleText'),
  ...ModelUtil.createAllValue('innerTitle/color', 'innerTitleColor'),
  ...ModelUtil.createAllValue('innerTitle/yOffset', 'innerTitleYOffset'),
  ...ModelUtil.createAllValue('innerTitle/fontFamily', 'innerTitleFontFamily'),
  ...ModelUtil.createAllValue('innerTitle/fontSize', 'innerTitleFontSize')
};